<template>
    <div
        v-show="scriptLoaded"
        class="wistia-wrap"
    >
        <div
            class="wistia-padding"
            :style="wrapStyle"
        >
            <div
                :class="videoClass"
                class="wistia_embed popover=true popoverAnimateThumbnail=true"
            />
        </div>
    </div>
</template>

<script>
import { loadScript } from '@/utils/scriptLoader';

export default {
    props: {
        videoId: {
            type: String,
            default: null,
        },

        height: {
            type: Number,
            default: 9,
        },

        width: {
            type: Number,
            default: 16,
        },

        responsive: {
            type: Boolean,
            default: true,
        },
    },

    /**
     * @returns {Array} Data.
     */
    data() {
        return {
            scriptLoaded: false,
            video: null,
        };
    },

    computed: {
        /**
         * Creates embed video class
         *
         * @returns  {string}  Embed video class.
         */
        videoClass() {
            return `wistia_async_${this.videoId}`;
        },

        /**
         * Video style
         *
         * @returns  {Array}  Style object.
         */
        wrapStyle() {
            return this.responsive
                ? {
                    width: '100%',
                    paddingTop: `${(this.height / this.width) * 100}%`,
                }
                : {
                    width: `${this.width}px`,
                    height: `${this.height}px`,
                };
        },
    },

    /**
     * Created hook
     */
    created() {
        window._wq = window._wq || [];
        window._wq.push({
            id: this.videoId,
            onReady: video => { this.video = video },
        });

        loadScript(
            `fast.wistia.com/embed/medias/${this.videoId}.jsonp`, `wistia_video_${this.videoId}`,
            () => { this.scriptLoaded = true }
        );
    },

    methods: {
        /**
         * Starts video playback
         *
         * @returns {void}
         */
        play() {
            if (this.video) {
                this.video.popover.show();
                this.video.play();
            }
        },
    },
};
</script>
